import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { addCrudCases } from '../../store/addCrudCases';
import { meetingThunks } from './meetingThunks';
import type { MeetingState } from './meetingTypes';

const initialState: MeetingState = {
  items: [],
  byId: {},
  currentItem: null,
  status: 'idle',
  error: null,
  filters: {},
  totalCount: 0,
};

export const meetingSlice = createSlice({
  name: 'meetings',
  initialState,
  reducers: {
    setMeetingFilters(state, action: PayloadAction<Partial<MeetingState['filters']>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearMeetingFilters(state) {
      state.filters = {};
    },
  },
  extraReducers: (builder) => {
    addCrudCases(builder, meetingThunks, (m) => m.meetingId);
  },
});

export const { setMeetingFilters, clearMeetingFilters } = meetingSlice.actions;
export const meetingReducer = meetingSlice.reducer;
